/**
 * Created by sunjinyu on 2018/11/13.
 */
import Vue from 'vue'
import {BigNumber} from 'bignumber.js'

Vue.filter('data', function (value, type) {
  if (!value) {
    return '0'
  }
  if (type) {
    return new Date(value).Format(type)
  } else {
    return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
  }
});

Vue.filter('textReplace', function (value, minLength, splice) {
  if (!value) {
    return ''
  };
  if (value.length <= minLength) {
    return value
  };
  return `${value.substring(0, splice)}...${value.substring(value.length - splice, value.length)}`;
});

Vue.filter('toFormat', function (value) {
  if (!value || value < 1000) {
    return value
  }
  return new BigNumber(value).toFormat();
});
Vue.filter('trim0', function (value) {
  value = value === 'object' && value.toString ? value.toString() : String(value);

  if (value[0] === '.') {
    value = '0' + value;
  }

  var part = value.split('.');
  if (part.length === 2) {
    part[1] = part[1].replace(/0+$/, ''); // remove suffixing zeros
    if (part[1] === '') {
      part.pop();
    }
  }

  part[0] = part[0].replace(/^0*/, ''); // remove leading zeros
  if (part[0] === '') {
    part[0] = '0';
  }
  return part.join('.');
});



// WEBPACK FOOTER //
// ./src/filter/index.js